module.exports = "<div class=\"back-home\">\n  <button type=\"button\" class=\"btn btn-sm pl-0 ml-0\" [routerLink]=\"'../..'\">\n    <span><i class=\"icon icon-arrow-back-breadcrumb text-uppercase\" aria-hidden=\"true\"></i>Home</span>\n  </button>\n</div>\n<div class=\"section-name col-sm-6 col-lg-12 p-0\">\n  All Storyboards\n</div>\n\n<app-storyboards [disableDrop]=\"true\" [hideAddButton]=\"true\" [hideModifyButton]=\"true\"></app-storyboards>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/views/storyboards-view/storyboards-view.component.html
// module id = ./src/app/views/storyboards-view/storyboards-view.component.html
// module chunks = main